import { FormControlLabel } from '@mui/material';
import TextField from '@mui/material/TextField';
import React, { ComponentPropsWithRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import styled from 'styled-components';

interface InputProps extends ComponentPropsWithRef<'input'> {
  name: string;
  shouldShowHelperText?: boolean;
}

export const Input = React.forwardRef((props: InputProps, ref: React.Ref<HTMLDivElement>) => {
  const {
    formState: { errors },
    control,
  } = useFormContext();

  const { shouldShowHelperText = false } = props;

  return (
    <Controller
      {...props}
      control={control}
      render={({ field }) => {
        return (
          <TextField
            inputProps={props}
            type={props.type || 'text'}
            {...field}
            value={field.value || ''}
            fullWidth
            ref={ref}
            error={!!errors[props.name]?.message}
            size="small"
            variant="outlined"
            name={props.name}
            helperText={shouldShowHelperText ? <>{errors?.[props.name]?.message}</> : null}
          />
        );
      }}
    />
  );
});

export const FormControlLabelStyled = styled(FormControlLabel)`
  border: 1px solid #000;
  padding: 5px 0;
  padding-right: 11px;
  margin-left: 0;
  border-radius: 3px;
`;

export const FormControlWrapper = styled.div`
  border: 1px solid #000;
  padding: 5px 11px;
  border-radius: 3px;
`;
